import { render, staticRenderFns } from "./ChallengesForm.vue?vue&type=template&id=357d66a8&scoped=true&"
import script from "./ChallengesForm.vue?vue&type=script&lang=js&"
export * from "./ChallengesForm.vue?vue&type=script&lang=js&"
import style0 from "./ChallengesForm.vue?vue&type=style&index=0&id=357d66a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357d66a8",
  null
  
)

export default component.exports